import { useEffect, useState } from 'react';
import { useQuery } from 'hooks';

function useTargetUser() {
  const query = useQuery();
  const [targetUser, setTargetUser] = useState(null);

  useEffect(() => {
    if (query) {
      const tUser = {
        userId: Number(query.get('userId')),
        fullName: query.get('fullName'),
        username: query.get('username'),
        image: query.get('image'),
      };
      if (tUser?.image) {
        tUser.image = atob(tUser.image);
      }

      if (tUser?.userId) {
        setTargetUser(tUser);
      }
    }
  }, []);

  return targetUser;
}

export { useTargetUser };
